let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lPCqB"), load("feg87"), load("jSPit"), load("gGI57"), load("7XPb0")]).then(() => parcelRequire('e56cD'));